import React from 'react';
import i18next from 'i18next';
import { Button } from 'antd';
import { CrownFilled } from '@ant-design/icons';

import { upgradeModal } from 'components/common/CheckPermissions/UpgradeSubscriptionModal';

const FallbackBtn = () => {
  const onClickButton = () => {
    upgradeModal.open();
  };

  return (
    <div className="delete-action-wrapper">
      <Button onClick={onClickButton}>{i18next.t('button.delete')}</Button>
      <CrownFilled className="action-feature-icon" />
    </div>
  );
};

export default FallbackBtn;
